const ITEMS = [
  "Purchase",
  "Refinance",
  "Top Up",
  "Construction",
  "Restructuring",
  "Residential",
  "Commercial",
  "SMSF",
];

const Group = ({ hidden }) => (
  <ul
    aria-hidden={hidden || undefined}
    className="flex shrink-0 items-center"
  >
    {ITEMS.map((item) => (
      <li key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl font-medium tracking-wide sm:text-2xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-ink/40" />
      </li>
    ))}
  </ul>
);

const Marquee = () => (
  <div
    className="toro-marquee relative overflow-hidden border-y border-ink/10 bg-sage py-5 text-ink"
    data-testid="editorial-marquee"
  >
    <div className="toro-marquee-track flex w-max">
      <Group />
      <Group hidden />
    </div>
  </div>
);

export default Marquee;
